import { useTranslation } from 'react-i18next';

import { PageMeta } from '@/components/layout/PageMeta';
import { Stack } from '@/components/layout/Stack';
import { Skeleton } from '@/components/ui/Skeleton';

export function ResolvingPage() {
  const { t } = useTranslation('cashier');
  const label = t('resolving.srLabel');

  return (
    <Stack gap="lg" aria-busy="true">
      <PageMeta title={t('meta.titleFallback')} />
      <h1 className="sr-only" tabIndex={-1}>
        {label}
      </h1>
      <div className="border-border bg-surface flex flex-col gap-3 rounded-lg border p-4">
        <Skeleton className="h-3.5 w-24" />
        <Skeleton className="h-7 w-40" label={label} />
        <Skeleton className="h-3.5 w-32" />
        <Skeleton className="h-11 w-full" />
      </div>
      <Skeleton className="h-7 w-full" />
      <Skeleton className="h-12 w-full" />
      <Skeleton className="h-12 w-full" />
    </Stack>
  );
}
